import { render, staticRenderFns } from "./CompanyHonors.vue?vue&type=template&id=01e1c19f&scoped=true&"
import script from "./CompanyHonors.vue?vue&type=script&lang=js&"
export * from "./CompanyHonors.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHonors.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CompanyHonors.vue?vue&type=style&index=1&id=01e1c19f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e1c19f",
  null
  
)

export default component.exports